// Utility functions for weekly plan calculations

export const calculateDayTotals = (data) => {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "None"];
  const totals = {};

  days.forEach(day => {
    const dayData = data.filter(item => item.day === day);
    
    totals[day] = {
      calories: dayData.reduce((acc, item) => acc + item.updated_total_calories, 0),
      cost: dayData.reduce((acc, item) => acc + item.updated_total_price, 0)
    };
  });

  return totals;
};

export const formatDayTotals = (totals) => {
  const formatted = {};
  
  Object.keys(totals).forEach(day => {
    formatted[day] = {
      calories: totals[day].calories.toLocaleString(undefined, { useGrouping: true }),
      cost: totals[day].cost.toLocaleString(undefined, { useGrouping: true })
    };
  });

  return formatted;
};

export const calculateMealServings = (multiplier, baseServings) => {
  // Handle invalid inputs
  const validMultiplier = isNaN(multiplier) || multiplier === "" ? 1 : parseFloat(multiplier);
  const validBaseServings = isNaN(baseServings) || baseServings === "" ? 1 : parseFloat(baseServings);
  
  const servings = validMultiplier * validBaseServings;
  
  if (isNaN(servings)) {
    return "1"; // Default to 1 serving if calculation fails
  }
  
  if (Number.isInteger(servings)) {
    return servings.toString();
  } else {
    return servings
      .toFixed(servings % 1 === 0.1 ? 1 : 2)
      .replace(/(\.0|0+)$/, "");
  }
};

export const filterRecipesByDay = (recipes, day) => {
  return recipes.filter(recipe => recipe.day === day);
};

export const filterRecipesByDayAndMeal = (recipes, day, meal) => {
  return recipes.filter(recipe => recipe.day === day && recipe.meal === meal);
};

export const groupRecipesByDayAndMeal = (recipes) => {
  const grouped = {};
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "None"];
  const meals = ["Breakfast", "Lunch", "Appetizer", "Dinner", "Dessert", "Snack"];

  days.forEach(day => {
    grouped[day] = {};
    meals.forEach(meal => {
      grouped[day][meal] = recipes.filter(recipe => recipe.day === day && recipe.meal === meal);
    });
  });

  return grouped;
};

export const calculateTotalCaloriesAndCost = (recipes) => {
  return recipes.reduce((acc, recipe) => {
    return {
      calories: acc.calories + recipe.updated_total_calories,
      cost: acc.cost + recipe.updated_total_price
    };
  }, { calories: 0, cost: 0 });
};